import { render } from "./News23.vue?vue&type=template&id=5a737da3&scoped=true"
import script from "./News23.vue?vue&type=script&lang=js"
export * from "./News23.vue?vue&type=script&lang=js"

import "./News23.vue?vue&type=style&index=0&id=5a737da3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a737da3"]])

export default __exports__